export default [
  {
    path: "proveedores",
    name: "suppliers",
    redirect: { name: "suppliers-list" },
    children: [
      {
        path: "",
        name: "suppliers-list",
        component: () => import("@/modules/suppliers/views/SuppliersList.vue"),
      },
      {
        path: ":id",
        name: "suppliers-show",
        redirect: { name: "supplier-products" },
        component: () => import("@/modules/suppliers/views/SupplierShow.vue"),
        children: [
          {
            path: "productos",
            name: "supplier-products",
            component: () =>
              import("@/modules/suppliers/views/show/SupplierProducts.vue"),
          },
          {
            path: "pedidos",
            name: "supplier-orders",
            component: () =>
              import("@/modules/suppliers/views/show/SupplierOrders.vue"),
          },
        ],
      },
    ],
  },
];
